/**
 * Format a number as currency (VND)
 * @param amount The amount to format
 * @returns Formatted string
 */
export const formatCurrency = (amount: number): string => {
  return new Intl.NumberFormat('vi-VN', {
    style: 'currency',
    currency: 'VND',
  }).format(amount);
};
